defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ClubGuide',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PageWrapper',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PromotionSpots'
  ],
  function (Component, PlayTogetherDictionary, CtaButton, PageWrapper, PromotionSpots) {

    // Component:
    Component('club-guide', [PlayTogetherDictionary], function (m, route, settings) {

      // Components:
      const root = {
        controller: function () {
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ClubGuide/' });
          this.promotionSpots = settings.promotionSpots;
          this.navigationPaths = settings.navigation;
        },

        view: function (controller) {
          const $content = [
            m(PromotionSpots, {
              controller
            }, {
              $footer: CtaButton({
                text: controller.dictionary('CreateClubButton'),
                href: controller.navigationPaths.createClubPage,
                options: ['primary']
              })
            })
          ];

          return PageWrapper({
            $content
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
